import { telegram } from "./telegram"

export interface TelegramUserData {
  firstName: string | null
  lastName: string | null
  username: string | null
  photoUrl: string | null
  telegramId: number | null
}

/**
 * Returns Telegram user data from initDataUnsafe.
 * Available instantly without server request.
 * Use as initial data before server response arrives.
 */
export function useTelegramUser(): TelegramUserData {
  const user = telegram.user

  return {
    firstName: user?.first_name || null,
    lastName: user?.last_name || null,
    username: user?.username || null,
    photoUrl: user?.photo_url || null,
    telegramId: user?.id || null,
  }
}
